import React from 'react';
import { Grid } from '@material-ui/core';
import LabelValue from 'eymp-uicomps/components/LabelValue';
import GlobalChip from 'src/new-ui/library/Chip';
import Vector from '../../../../assets/dashboardIcons/Vector.png';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { CASE_DATA_COLLECT_COMPOSE_URL } from 'src/constants/constants';
import { fnSetIsAllCaseToggle } from 'src/helpers/commonFunctions';
import intl from 'react-intl-universal';
import DOMPurify from 'dompurify';
export class ActionBlockPres extends React.Component {
  handleOnClick() {
    const { entityId, pageId } = this.props.caseData;
    sessionStorage.setItem('case_nav', true);
    fnSetIsAllCaseToggle(false);
    window.location.href = DOMPurify.sanitize(CASE_DATA_COLLECT_COMPOSE_URL + '/' + this.props.caseId + '/' + entityId + '/' + pageId);
  }

  render() {
    return (
      <Grid item sm={12}>
        <Grid className="header-wrap">
          <LabelValue value="ACTION ITEMS" />
        </Grid>
        <Grid className="actions-block-wrapper cursor-pointer">
          {this.props.caseData ? (
            <div className="d-flex w-100 align-items-center" onClick={() => this.handleOnClick()}>
              <div>
                <GlobalChip data={this.props.caseDetail} />
              </div>
              <div>
                <span className="view-case">{intl.get('newDashboard.actionBlock.label')}</span>
              </div>
              <div>
                <img src={Vector} alt="next" />
              </div>
            </div>
          ) : (
            <div style={{ margin: 'auto' }}>
              <Spinner size={30} />
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}
export default ActionBlockPres;
